import React, {useMemo, useRef} from 'react';
import {useSelfieUploadState} from "../selfie_context";

export const FileSelect = React.forwardRef((props, ref) => {
  const {mode, setFile} = useSelfieUploadState()
  const inputRef = useRef(null)

  const accept = useMemo(() => {
    switch (mode) {
      case "video":
        return "video/mp4,video/webm"
      case "image":
        return "image/png, image/jpeg, image/gif"
      default:
        throw new Error(`Unknown mode: ${mode}`)
    }
  }, [mode])

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      setFile(file)
    }
  }

  return <>
    <input style={{display: "none"}} ref={ref} type="file" accept={accept} onChange={handleFileChange}/>
  </>
});
